export default __webpack_public_path__ + "static/media/united-states.a334f236.svg";